<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4>Download Gambar</h4>
        <p>Download gambar untuk kamu posting di Instagram.</p>
        <ul v-if="d">
          <a :href="d.imgUri" download target="_blank">
            <div class="img feed"></div>
            <span>Gambar kotak untuk IG Feed</span>
          </a>
          <a :href="d.storyUri" download target="_blank">
            <div class="img story"></div>
            <span>Gambar 9:6 untuk IG Story</span>
          </a>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'downloadChooser',
  components: {},
  data() {
    return {
      show: false,
      next: null,
      d: null,
    };
  },
  methods: {
    open(d, next) {
      this.d = d;
      this.next = next;
      this.show = true;
    },
    close(b, v) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, v);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      max-width: 320px;
      @media (max-width: 450px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 30px;
      }
      .close{
        position: absolute;
        right: 20px; top: 20px;
        background-color: #ddd;
        width: 32px; height: 32px;
        background-image: url(../assets/close.png);
        opacity: .65;
        background-size: 12px auto;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 50%;
        &:hover{
          background-image: url(../assets/close-white.png);
          background-color: #5351a4;
          opacity: 1;
        }
        @media (max-width: 1480px) {
          width: 28px; height: 28px;
          background-size: 10px auto;
        }
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      p{
        margin: 0 0 10px;
        opacity: .65;
        &.info{
          margin: 20px 0 0;
          text-align: center;
          font-size: 13px;
        }
      }
      ul{
        padding: 10px 0 0;
        margin: 0;
        a{
          list-style: none;
          display: block;
          padding: 0 34px;
          border-radius: 4px;
          margin-bottom: 10px;
          position: relative;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          height: 54px;
          font-size: 16px;
          font-weight: 400;
          padding-left: 50px;
          cursor: pointer;
          transition: all .3s ease;
          border: #eee 1px solid;
          // color: #444;
          box-shadow: 2px 2px 2px rgba(0,0,0,.1);
          span{
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          &:before{
            content: "";
            position: absolute;
            right: 10px; top: 17px;
            width: 14px; height: 14px;
            background-image: url(../assets/download-o.png);
            background-size: 14px auto;
          }
          &:hover{
            background-color: #f5f5fe;
          }
          .img{
            height: 28px; width: 28px;
            position: absolute;
            left: 12px; top: 12px;
            background-color: #5351a4;
            &.story{
              height: 40px; top: 6px;
            }
          }
        }
      }
    }
  }
</style>
